export const themeConstants = {
	LIGHT: 'light',
	DARK: 'dark',
}
